import { CalendarToday, Person } from "@mui/icons-material"
import { Box, Stack, Typography } from "@mui/material"

export default function RecordMetadata({ at, name, title }) {
	if (!at) return null
	return (
		<div>
			<Stack>
				<Typography
					variant="h6"
					component="h3"
					gutterBottom
					fontWeight="600"
					color="text.primary"
				>
					{title}
				</Typography>
				<Box>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
						<Person fontSize="small" color="action" />
						<Typography variant="body2" color="text.secondary">
							{name}
						</Typography>
					</Box>
				</Box>
				<Box>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
						<CalendarToday fontSize="small" color="action" />
						<Typography variant="body2" color="text.secondary">
							{at}
						</Typography>
					</Box>
				</Box>
			</Stack>
		</div>
	)
}
